/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum ActionTokenEntity {
  CONTRACT = 'contract',
  COMPANY = 'company',
}
